<template>
  <div v-if="apis.length > 0">
    <CDropdown
      class="dropdown-api"
      :placement="placement"
      color="primary"
      variant="btn-group"
      :togglerText="'ALTERAR NEGÓCIO'"
    >
      <CDropdownMenu>
        <CDropdownItem
          @click="changeApi(api)"
          v-for="api in apis"
          :key="api.API_URL"
        >
          <img
            :src="`${api.API_URL}/images/favicon/icon-72x72/s/ADMIN`"
            alt="Icone sistema"
            class="api-icon"
          />
          <span class="api-name">
            {{ api.NAME }}
          </span>
          <span
            class="status-dot"
            :class="{
              'status-dot-logged':
                hasTokenForApi(api) || api.API_URL === config.api,
              'status-dot-anonymous': !(
                hasTokenForApi(api) || api.API_URL === config.api
              ),
            }"
            :title="
              hasTokenForApi(api) || api.API_URL === config.api
                ? 'Sessão ativa nesta instalação'
                : 'Precisa fazer login'
            "
          ></span>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  </div>
</template>

<script>
import config from "../config";
import _find from "lodash/find";
import {
  clearAllTokens,
  getTokenForApi,
  hasTokenForApi,
  removeTokenForApi,
  setTokenForApi,
} from "../helpers/cache";

export default {
  name: "ApiUrlChange",
  props: {
    placement: {
      type: String,
      default: "bottom-start",
    },
  },
  data() {
    return {
      apis: [],
      active: null,
      config,
    };
  },
  methods: {
    hasTokenForApi,
    applyInstallation(api) {
      localStorage.setItem("API_URL", api.API_URL);
      if (api.CDN_URL) localStorage.setItem("CDN_URL", api.CDN_URL);
      if (api.WS_HOST) localStorage.setItem("WS_HOST", api.WS_HOST);
      if (api.WS_KEY) localStorage.setItem("WS_KEY", api.WS_KEY);
      if (api.WS_PORT) localStorage.setItem("WS_PORT", api.WS_PORT);
    },
    preservaTokenAtual() {
      const tokenAtual = localStorage.getItem("token");
      if (tokenAtual && config.api) {
        setTokenForApi(config.api, tokenAtual);
      }
    },
    logoutAndGoToInstallation(api) {
      this.applyInstallation(api);
      clearAllTokens();
      localStorage.removeItem("token");
      localStorage.removeItem("app");
      window.location.href = "/login";
    },
    async changeApi(api) {
      if (!api || !api.API_URL) return;
      if (api.API_URL === config.api) return;

      this.preservaTokenAtual();

      const tokenAlvo = getTokenForApi(api.API_URL);

      if (!tokenAlvo) {
        // Usuario ja deslogado: vai direto, nao ha sessao a perder.
        if (!localStorage.getItem("token")) {
          this.logoutAndGoToInstallation(api);
          return;
        }
        // Sem token salvo na destino mas logado na atual: confirma com o
        // usuario que ele sera deslogado da sessao atual e levado para o
        // /login da instalacao destino.
        if (!window.swal) {
          this.logoutAndGoToInstallation(api);
          return;
        }
        const confirmed = await window.swal({
          title: "Trocar de negócio?",
          text: `Você ainda não tem sessão em "${api.NAME || "esta instalação"}". Continuar vai deslogar você da sessão atual e levar para a tela de login dessa instalação.`,
          icon: "warning",
          buttons: {
            cancel: { text: "Cancelar", value: false, visible: true },
            confirm: { text: "Continuar", value: true },
          },
          dangerMode: true,
        });
        if (confirmed) {
          this.logoutAndGoToInstallation(api);
        }
        return;
      }

      // Valida sessao com o token alvo antes de aplicar a troca.
      // Usa /admin/carga ja que matamos dois coelhos: valida e atualiza
      // a `app` em localStorage para a nova instalacao.
      let cargaJson = null;
      try {
        const resp = await fetch(`${api.API_URL}/admin/carga`, {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenAlvo}` },
        });
        if (!resp.ok) throw new Error("Sessao invalida");
        cargaJson = await resp.json();
      } catch (e) {
        removeTokenForApi(api.API_URL);
        if (window.swal) {
          window.swal({
            title: "Sessão expirada",
            text: "Faça login novamente nesta instalação.",
            icon: "warning",
          });
        }
        return;
      }

      // OK: ativa a instalacao destino e da reload.
      localStorage.setItem("token", tokenAlvo);
      if (cargaJson) {
        localStorage.setItem("app", JSON.stringify(cargaJson));
      } else {
        localStorage.removeItem("app");
      }
      this.applyInstallation(api);
      window.location.reload();
    },
  },
  beforeMount() {
    this.active = _find(config.apis, { API_URL: config.api });
    this.apis = config.apis || [];
  },
};
</script>

<style scoped>
.api-url {
  display: block;
}
.api-icon {
  max-width: 22px;
  max-height: 22px;
  margin-right: 10px;
  object-fit: contain;
  overflow: hidden;
}
.api-name {
  font-size: 13px;
}
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: auto;
}
.status-dot-logged {
  background-color: #2e7d32;
}
.status-dot-anonymous {
  background-color: #bdbdbd;
}
.dropdown-api ::v-deep .dropdown-menu {
  max-height: 20vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
